import Backbone from 'backbone';
import Handlebars from 'handlebars';
import Utils from '../utils';
import MyCheckV3 from './../../components/mycheck-v3';
import Form from './../../base/form.js';
import Spinner from './../../components/spinner.js';
import { EventHandler } from './../../../base/utils.js';
import {
  requestUrls,
  templateUrls
} from './../../../base/vars.js';
import UserHandler from './../../base/user.js';

export default Backbone.View.extend({
  el: '.app-step-container',

  events: {
    'change #addressType0': 'displayBusinessName',
    'focusout input, select': 'handleValidation',
    'input input': 'handleValidation',
    'change select': 'handleValidation',
    'change #businessEnrollmentCheckbox': 'toggleBussinessEnrollmentDropdown',
    'submit': 'onSubmit'
  },

  initialize() {
    this.extendValidation();
    this.getTemplate();
    $(document).on('user:binding:complete', () => {
      Utils.triggerFormChecks();
      this.displayBusinessName();
      Form.displayLockedCountry();
      Form.displayLockedMemberName();
      Form.onCountryChange();
      if ($('.mycheck-v3-component').length) {
        MyCheckV3.getMyCheckParams();
      }
      Spinner.remove(this.$('form'));
    });
  },

  extendValidation() {
    _.extend(this.model.validation, {
      'addresses.0.businessName': {
        required: false,
        maxLength: 200
      },
      'addresses.0.address1': {
        required: false,
        maxLength: 200
      },
      'addresses.0.address2': {
        required: false,
        maxLength: 200
      },
      'addresses.0.address3': {
        required: false,
        maxLength: 200
      },
      'addresses.0.city': {
        required: false,
        maxLength: 100
      }
    });
  },

  getTemplate() {
    $.ajax({
      url: templateUrls.profile,
      context: {
        onFail: {
          scrollToElement: $('body')
        }
      },
      success: (r) => {
        let html = this.removeAdditionalFields(r);
        this.template = Handlebars.compile(html);
        this.render();
        window.App.Events.trigger('form:loaded');
        EventHandler.triggerEvent('rewards_profile', {
          pageName: 'profile'
        });
        EventHandler.send(EventHandler.lazyLoad.rebind);
      }
    });
  },

  removeAdditionalFields(html) {
    let $html = $(DOMPurify.sanitize(html));
    //If flow is not enroll
    if (Utils.applicationFlow !== 'enroll') {
      //Remove addressType
      $html.find('#businessName0').parents('.flex-form-row').remove();
    }
    //Remove business Enrollment if it was set previously
    if (this.model.get('preferences.BUSTRAVTYPE')) {
      $html.find('.business-enrollment-wrapper').remove();
    }
    return $html.html();
  },

  displayBusinessName() {
    Form.displayBusinessName();
  },

  handleValidation(e) {
    Utils.setBindingAttribute(this.model, e);
    Utils.validateBindingAttribute(this.model, e);
    Utils.handleSubmitButton(this.model, this.$('.submit'), e);
  },

  onSubmit(e) {
    let isValid = Utils.isValid(this.model),
      options = {
        context: {
          onFail: {
            scrollToElement: $('body'),
            formElement: this.$('form')
          }
        }
      };

    let $submit = this.$('.submit');
    Form.disableFormField($submit);

    let submitText = $submit.text(); // keep reference to original authored text
    $submit.text($submit.data('successLabel')); // using form container success author field for "processing" text

    if (requestUrls && requestUrls['updateProfile'] && isValid) {
      //Cleanup businessEnrollment before submit to enroll
      Utils.updateBusinessEnrollmentPayload(this.model);
      this.model.updateProfile(null, options)
        .done((response) => {
          Utils.captureBusinessEnrollmentAnalytics();
          Backbone.history.loadUrl('spinner');
        })
        .fail((response, options) => {
          $submit.text(submitText);
        });
    } else {
      Utils.scrollToTop();
      $submit.text(submitText);
      Form.enableFormField($submit);
    }
  },

  checkStateBussinessEnrollmentInitState() {
    let $btCheckbox = $('#businessEnrollmentCheckbox');
    if ($btCheckbox.length > 0) {
      Utils.toggleBussinessEnrollmentDropdown($btCheckbox);
    }
  },

  toggleBussinessEnrollmentDropdown(e) {
    let $btCheckbox = $(e.currentTarget);
    Utils.toggleBussinessEnrollmentDropdown($btCheckbox);
  },

  render() {
    Utils.nextStep(2);
    this.$el.html(this.template(this.model.toJSON()));
    this.checkStateBussinessEnrollmentInitState();
    Utils.bindBackboneValidation(this);
    UserHandler.renderUserData();
  }
});
